// extracted by mini-css-extract-plugin
export var attachment = "_s1-a";
export var emailContainer = "_s1-4";
export var emailContentPaddedContainer = "_s1-b";
export var emailHeader = "_s1-6";
export var emailIframe = "_s1-3";
export var emailInfoIcon = "_s1-9";
export var emailShortenedSummary = "_s1-e";
export var infoDropdown = "_s1-0";
export var infoRowBoundedContent = "_s1-d";
export var internal = "_s1-5";
export var merchant = "_s1-8";
export var messageInputContainer = "_s1-h";
export var normal = "_s1-7";
export var replyCard = "_s1-f";
export var subtleButton = "_s1-1";
export var subtleButtonIconContainer = "_s1-2";
export var toggleViewRepliesButton = "_s1-c";
export var wrappingText = "_s1-g";